import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonNavigationDrawer } from './NavigationDrawer.definition';
import { chameleonNavigationDrawerHeader } from './NavigationDrawerHeader/NavigationDrawerHeader.definition';
import { chameleonNavigationDrawerItem } from './NavigationDrawerItem/NavigationDrawerItem.definition';
import { chameleonNavigationDrawerLink } from './NavigationDrawerLink/NavigationDrawerLink.definition';
import { chameleonNavigationDrawerSection } from './NavigationDrawerSection/NavigationDrawerSection.definition';
import { register as registerTypography } from '@getgo/chameleon-typography/register';
export function registerCustom(prefix, node) {
    registerTypography({ prefix, node });
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonNavigationDrawer(), chameleonNavigationDrawerLink(), chameleonNavigationDrawerItem(), chameleonNavigationDrawerHeader(), chameleonNavigationDrawerSection());
}
